module.exports = __webpack_public_path__ + "static/media/open-sans-v15-latin-italic.f42df73d.ttf";